import React from 'react';
import { Modal } from 'react-bootstrap';
import { Translate as t } from '../../config/Translate';

// 선택 props (기존 호출처는 모두 생략 → 동작 불변)
//  closeLabel    : 닫기 버튼 문구 (기본 common.button.close). 취소 의미일 때 common.button.cancel 전달
//  closeDisabled : 닫기 버튼/배경 클릭·ESC 닫기 차단 (비동기 실행 중 이중 제출 방지)
//  zIndex        : 다른 모달 위에 겹쳐 열 때 지정
//  actions[].disabled / actions[].key : 액션 버튼 비활성 / React key (미지정 시 title·index)
export const ModalConfirm = ({ info, callbackClose, isActionSheet = false, closeLabel, closeDisabled = false, zIndex }) => {
	const safeInfo = info || {};
	const actions = Array.isArray(safeInfo.actions) ? safeInfo.actions : [];
	return (
		<Modal
			show={!!safeInfo.showModal}
			onHide={() => { if (!closeDisabled) callbackClose(); }}
			className={isActionSheet ? "action-sheet" : ""}
			style={zIndex ? { zIndex } : undefined} >
			<Modal.Header>
				<h2 className="modal-title">{safeInfo.title}</h2>
			</Modal.Header>
			<Modal.Body className={isActionSheet ? "p-2" : ""}>
				{safeInfo.content}
			</Modal.Body>
			<Modal.Footer>
				{actions.map((x, idx) => {
					return <button
						key={x.key ?? `${x.title ?? 'action'}-${idx}`}
						type="button"
						className={x.css || "btn btn-block btn-success"}
						disabled={!!x.disabled}
						onClick={() => x.callback()}>
						{x.title}
					</button>
				})}
				<button type="button" className="btn btn-block btn-dark" disabled={closeDisabled} onClick={() => callbackClose()}>{closeLabel || t('common.button.close')}</button>
			</Modal.Footer>
		</Modal>
	);
}
